import * as yup from 'yup'

export const myCompanyFormSchema = yup.object({
  companyName: yup.string().required().default('').nullable(),
})
